<template>
  <v-container id="vendors" fluid tag="section">
    <div class="text-right">
      <v-btn
        color="cyan"
        @click="showFilter = !showFilter"
        small
        v-if="showGrid"
      >
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-btn
        color="secondary"
        class="mr-0"
        small
        v-if="singlePage && !showGrid"
        @click="
          showGrid = !showGrid;
          client_id = null;
        "
      >
        <v-icon>mdi-grid</v-icon>
        {{ $i18n.t("All") }}
      </v-btn>
      <v-menu offset-y v-if="showGrid">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="secondary" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/settings/vendor/add'" v-if="!singlePage">
            <v-list-item-title>{{ $i18n.t("Create") }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="uploadV  ()" v-if="!singlePage">
            <v-list-item-title>{{ $i18n.t("Bulk Upload") }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="
              showGrid = !showGrid;
              vendor_id = null;
            "
            v-if="singlePage"
          >
            <v-list-item-title>{{ $i18n.t("Create") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <vendor-add
      v-if="!showGrid && vendorAdd"
      :singlePage="singlePage"
      @select="select"
    />

    <vendor-edit
      v-if="!showGrid && !vendorAdd"
      :vendor_id="vendor_id"
      :singlePage="singlePage"
      @select="select"
    />

    <v-row justify="center" v-if="showFilter && showGrid">
      <v-col cols="12" md="12">
        <base-material-card
          color="cyan"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn
              color="black"
              class="mr-0"
              fab
              small
              text
              @click="showFilter = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Name')"
                class="purple-input"
                v-model="filters.name"
                @keyup.enter="search"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Unique ID')"
                class="purple-input"
                v-model="filters.unique_id"
                @keyup.enter="search"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('GSTIN')"
                class="purple-input"
                v-model="filters.gstin"
                @keyup.enter="search"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Account No')"
                class="purple-input"
                v-model="filters.accNo"
                @keyup.enter="search"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-select
                clearable
                v-model="filters.approved"
                :items="statuses"
                :label="$i18n.t('Status')"
              />
            </v-col>
            <v-col cols="12" md="2">
              <z-country-select v-model="filters.country" />
            </v-col>
            <v-col cols="12" md="2">
              <z-city-select
                v-model="filters.city"
                :country="filters.country"
              />
            </v-col>

            <v-col cols="12" md="3" class="text-right">
              <!-- <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="orange"
                    fab
                    text
                    small
                    @click="downloadVendors()"
                    style="margin-right: 10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cloud-download</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Download") }}</span>
              </v-tooltip> -->
              <v-btn
                color="cyan"
                class="mr-2"
                small
                dark
                @click="downloadV()"
                :loading="loading"
              >
                {{ $i18n.t("Download") }} <v-icon>mdi-cloud-download-outline</v-icon>
              </v-btn>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    small
                    @click="clear(1)"
                    style="margin-right: 10px !important"
                    v-on="on"
                  >
                    {{ $i18n.t("Refresh") }}
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                dark
                small
                @click="search()"
                :loading="loading"
              >
                {{ $i18n.t("Search") }}
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="showGrid && grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width: 100%"
      :loading="loading"
      >{{ $i18n.t("No records available") }}</v-btn
    >

    <base-material-card
      icon="mdi-domain"
      :title="$i18n.t('Vendors')"
      class="px-5 py-3 small-icon"
      v-if="showGrid && grid.records"
      color="primary"
    >
      <z-grid-record :grid="grid" />
      <v-simple-table>
        <thead>
          <tr>
            <th class="primary--text">{{ $i18n.t("ID") }}</th>
            <th class="primary--text">{{ $i18n.t("Name") }}</th>
            <th class="primary--text">{{ $i18n.t("Address") }}</th>
            <th class="primary--text">{{ $i18n.t("Admin Name") }}</th>
            <th class="primary--text">{{ $i18n.t("Admin Email") }}</th>
            <th class="primary--text">{{ $i18n.t("Admin Phone") }}</th>
            <th class="primary--text">{{ $i18n.t("Status") }}</th>
            <th class="primary--text"></th>
            <th class="text-right primary--text">{{ $i18n.t("Action") }}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="vendor in grid.rows" :key="vendor._id">
            <td>{{ vendor.vendor.unique_id }}</td>
            <td>{{ vendor.vendor ? vendor.vendor.name : "" }}</td>
            <td>
              <span
                v-if="
                  vendor.entity &&
                  vendor.entity.address &&
                  vendor.entity.address.city
                "
                title="City"
                >{{ vendor.entity.address.city }},</span
              >
              <span
                v-if="
                  vendor.entity &&
                  vendor.entity.address &&
                  vendor.entity.address.country
                "
                title="Country"
              >
                {{ vendor.entity.address.country }}</span
              >
            </td>
            <td>
              <span
                class="fa fa-user"
                v-if="vendor.adminUser && vendor.adminUser.name"
                >{{ vendor.adminUser.name }}</span
              >
            </td>
            <td>
              <span
                class="fa fa-envelope"
                v-if="vendor.adminUser && vendor.adminUser.email"
                >{{ vendor.adminUser.email }}</span
              >
            </td>
            <td>
              <span
                class="fa fa-phone"
                v-if="vendor.adminUser && vendor.adminUser.phone"
                >{{ vendor.adminUser.countryCode }}</span
              >
              <span
                v-if="
                  vendor.adminUser &&
                  vendor.adminUser.countryCode &&
                  vendor.adminUser.phone
                "
              >
                -
                {{ vendor.adminUser.phone }}
              </span>
            </td>
            <td>
              <span v-if="!vendor.vendor.approved">Pending</span>
              <span v-if="vendor.vendor.approved">Approved</span>
            </td>
            <td>
              <span v-if="vendor.vendor.approved">
                <z-confirm-button
                  small
                  fab
                  text
                  class="btn btn-green rounded btn-u-xs"
                  @click="sendVendorValue(vendor._id, 0)"
                  :message="$i18n.t('Are you sure you want to unapprove this?')"
                >
                  <v-icon>mdi-check</v-icon>
                </z-confirm-button>
              </span>
              <span v-if="!vendor.vendor.approved">
                <z-confirm-button
                  small
                  fab
                  text
                  class="btn btn-warning rounded btn-u-xs"
                  @click="sendVendorValue(vendor._id, 1)"
                  :message="$i18n.t('Are you sure you want to approve this?')"
                >
                  <v-icon>mdi-close</v-icon>
                </z-confirm-button>
              </span>
            </td>
            <td>
              <z-confirm-button
                v-if="vendor.showDelete && !vendor.isPremium"
                class="float-right"
                color="red lighten-1"
                small
                fab
                text
                dark
                :message="$i18n.t('Do you want to remove this vendor ?')"
                @click="deleteVendor(vendor)"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </z-confirm-button>
              <v-tooltip top v-if="!singlePage">
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="float-right"
                    color="primary"
                    small
                    fab
                    text
                    dark
                    :to="'/settings/vendor/' + vendor._id"
                    v-on="on"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Edit") }}</span>
              </v-tooltip>

              <v-tooltip top v-if="singlePage">
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="float-right"
                    color="primary"
                    small
                    fab
                    text
                    dark
                    @click="editVendor(vendor._id)"
                    v-on="on"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Edit") }}</span>
              </v-tooltip>
              <v-tooltip top v-if="showSelectBtn && vendor.vendor.approved">
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="float-right"
                    color="success"
                    small
                    fab
                    text
                    dark
                    @click="select(vendor)"
                    v-on="on"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Select") }}</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>

    <v-dialog
      v-model="download.showDialog"
      transition="dialog-top-transition"
      style="width:40%; !important"
    >
      <v-card>
        <v-toolbar color="white" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-filter</v-icon>
            {{ $i18n.t("Download") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="download.showDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    :items="download.types"
                    :label="$i18n.t('Select Format')"
                    item-text="name"
                    item-value="_id"
                    v-model="download.template"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions class="sticky-bottom">
          <v-spacer></v-spacer>
          <v-btn
            color="orange"
            class="mr-0"
            fab
            small
            dark
            @click="downloadAll()"
            :loading="loading"
          >
            <v-icon>mdi-cloud-download</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <z-download-file
      :requestURL="downloadVendorsUrl"
      :showDialog="showDownloadByTemplateDialog"
      @closeDialog="closeDialog"
      :kind="7"
      :forUpload="forUpload"
    />
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import VendorAdd from "@/views/vendor/VendorAdd.vue";
import VendorEdit from "@/views/vendor/VendorEdit.vue";

@Component({
  components: {
    VendorAdd,
    VendorEdit,
  },
  props: {
    singlePage: {
      default: false,
    },
    showGrid1: {
      default: true,
    },
    showSelectBtn: {
      default: false,
    },
  },
})
export default class Vendors extends Vue {
  grid = { page: 0 };
  rows = 20;
  url = "/api/vendors/grid?rows=" + this.rows;
  showFilter = false;
  filterUrl = "";
  page = 1;
  showGrid = true;
  vendor_id = null;
  vendorAdd = true;
  showDownloadByTemplateDialog = false;
  forUpload = false;

  filters = {
    name: null,
    fullName: null,
    unique_id: null,
    country: null,
    city: null,
    approved: null,
    gstin: null,
    accNo: null,
  };

  statuses = [
    { value: "true", text: "Approved" },
    { value: "NULL", text: "Penidng" },
  ];

  download = {
    showDialog: false,
    template: null,
    types: [],
    templateList: [],
  };

  downloadVendorsUrl = null;
  async downloadV() {
    const downloadUrl =
      "/api/corp/download/vendor?_search=true" + this.getFilteredUrl();
    this.downloadVendorsUrl = downloadUrl;
    this.forUpload = false;
    this.showDownloadByTemplateDialog = true;
  }

  async uploadV() {
    this.downloadVendorsUrl =
      "/api/corp/upload/vendors?_search=true" + this.getFilteredUrl();
    this.forUpload = true;
    this.showDownloadByTemplateDialog = true;
  }

  async fetchTemplates() {
    this.download.templateList = await doGet("/api/template/9/options");
  }

  // downloadVendors() {
  //   if (this.download.templateList) {
  //     for (let i = 0; i < this.download.templateList.length; i++) {
  //       if (i == 0) {
  //         this.download.template = this.download.templateList[i]._id;
  //       }
  //       this.download.types.push({
  //         _id: this.download.templateList[i]._id,
  //         name: this.download.templateList[i].name + "(Template)",
  //       });
  //     }
  //   }
  //   this.showFilter = false;
  //   this.download.showDialog = true;
  // }

  // async downloadAll() {
  //   const type = this.download.template;
  //   let url = "/api/corp/download/vendor?_search=true";
  //   url = url + this.getFilteredUrl();
  //   if (type) {
  //     if (type.length > 20) {
  //       url = url + "&template_id=" + type;
  //     } else {
  //       url = url + "&type=" + type;
  //     }
  //   }

  //   window.open(url, "_blank");
  // }

  get loading() {
    return common.loading;
  }

  closeDialog(reload) {
    this.showDownloadByTemplateDialog = false;
    common.setLoading(false);
    if (reload) this.reload();
  }

  async reload() {
    this.showPage(this.page);
  }

  editVendor(_id) {
    //This is used for single page application
    this.vendor_id = _id;
    this.showGrid = false;
    this.vendorAdd = false;
  }

  select(data) {
    this.$emit("select", { _id: data._id, name: data.name });
    this.showGrid = true;
  }

  async mounted() {
    this.fetchTemplates();
    this.showGrid = this.showGrid1;
    common.setLoading(true);
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.filters = {};
    this.page = 1;
    this.search();
  }

  getFilteredUrl() {
    let filterUrl = "";
    if (this.filters.name) filterUrl += "&name=" + this.filters.name;
    if (this.filters.accNo) filterUrl += "&accNo=" + this.filters.accNo;
    if (this.filters.gstin) filterUrl += "&gstin=" + this.filters.gstin;
    if (this.filters.fullName)
      filterUrl += "&fullName=" + this.filters.fullName;
    if (this.filters.unique_id)
      filterUrl += "&unique_id=" + this.filters.unique_id;
    if (this.filters.country) filterUrl += "&country=" + this.filters.country;
    if (this.filters.city) filterUrl += "&city=" + this.filters.city;
    if (this.filters.approved)
      filterUrl += "&approved=" + this.filters.approved;
    return filterUrl;
  }

  async search() {
    this.filterUrl = this.getFilteredUrl();
    common.setLoading(true);
    await this.showPage(1);
  }

  async sendVendorValue(id, status) {
    try {
      await doGet("/api/corp/" + id + "/approve/vendor/" + status);
      common.showMessage("Status Successfully Updated");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async deleteVendor(vendor) {
    try {
      await doGet("/api/vendor/" + vendor._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.btn-list-item {
  padding: 0;
  float: left !important;
}
.btn-list-item .v-btn--text {
  padding: 0;
  text-transform: none;
  font-size: 14px;
  float: left;
  margin: 0;
}
</style>
